import _defineProperty from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickComponentCommonProps } from '../../interfaces/commonProps';
import { useLocale } from '../LocaleProvider';
import { StyledStaticLabel, StyledAnimatedLabel, StyledOptionalText } from './FormLabel.styles';
export var FormLabel = function FormLabel(_ref) {
  var as = _ref.as,
      children = _ref.children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      _ref$empty = _ref.empty,
      empty = _ref$empty === void 0 ? false : _ref$empty,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      htmlFor = _ref.htmlFor,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      restProps = _objectWithoutProperties(_ref, ["as", "children", "disabled", "variant", "empty", "invalid", "htmlFor", "required", "readOnly"]);

  var StyledLabel;

  switch (variant) {
    case 'scale':
    case 'float':
      StyledLabel = StyledAnimatedLabel;
      break;

    case 'static':
    case 'default':
    default:
      StyledLabel = StyledStaticLabel;
  }

  var locale = useLocale();
  return React.createElement(StyledLabel, _objectSpread({
    as: as,
    "data-testid": "testid_".concat(htmlFor),
    disabled: disabled,
    variant: variant,
    empty: empty,
    invalid: invalid,
    htmlFor: htmlFor,
    outerSpacing: useSpacing(restProps),
    required: required,
    readOnly: readOnly
  }, pickComponentCommonProps(restProps)), children, ' ', !required && React.createElement(StyledOptionalText, null, locale.formLabel.optional));
};